import React, { useEffect, useState } from "react"
import HTMLReactParser from 'html-react-parser';
import CTABtnModule from "../../modules/cta_btn_module";
import { Col, Container, Row } from "react-bootstrap";

import "./PageBanner.scss"

// Header component

const PageBanner = ({Module}) => {
    return (
        <React.Fragment>
            <section className={`landing-page-banner`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="page-banner-inner">
                                <div className="page-banner-content">
                                    <h3>{Module.title}</h3>
                                    {Module.content && HTMLReactParser(Module.content)}
                                </div>
                                <CTABtnModule button_cta={Module?.button_cta}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default PageBanner;

